import type { Moment } from 'moment';
import moment from 'moment';

const isSameMonth = (
  firstDate: Moment | string | null,
  secondDate: Moment | string | null
): boolean => {
  if (!firstDate || !secondDate) {
    return false;
  }

  const firstMoment = moment(firstDate);
  const secondMoment = moment(secondDate);

  // Compare year and month directly to avoid timezone conversion issues
  return (
    firstMoment.year() === secondMoment.year() &&
    firstMoment.month() === secondMoment.month()
  );
};

export default isSameMonth;
